import { z } from 'zod';
import { ValidationRules } from './validation-rules';

// Password form schema - matches current validation (required field only)
export const passwordSchema = z.object({
  password: ValidationRules.password,
});

// Type inference from schema
export type PasswordFormData = z.infer<typeof passwordSchema>;

// Default values
export const passwordFormDefaults: PasswordFormData = {
  password: '',
};
